// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"387":"e64c30b0","9464":"770f3eb3","9615":"8606f36f"}[chunkId] + ".chunk.css";
};